module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/vo9wXo/image/1.png?1708992389114",
      "alt": "This image is the cover for the book Billy's Brainwave"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Billy's Brainwave\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Eleven-year-old Billy Barnes lives with his parents and elder sister, Julia. He is usually a happy boy and spends most of his time with one of his best friends, Ali Patel. However, Billy has a problem. A big problem! He was stopped by some older boys as he was on his way home from school. One of them demanded protection money from Billy and made it quite clear that it was pay up, or suffer the consequences! Just how are Billy and Ali going to solve this problem, without involving Billy’s parents? If he does that, he runs a considerable risk of becoming a laughingstock in his class. He can almost hear some of the other boys shouting, “Billy Barnes has to ask his mum and dad for help, just like in reception class!” The solution is as clever as it is simple and is the start of a number of exciting adventures for Billy and Ali.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Ian Buttle\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Ian Buttle was born in Kent. After completing teacher training in Leicester, he taught in a secondary school in North London for some years. He married and moved to Denmark in the mid 70s, in search of a new challenge. He taught there for a number of years until his retirement. He has two daughters and six grandchildren, with whom he has a close and loving relationship.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 71
// module chunks = 0